import { Link } from 'react-router-dom';
import type { SolCompanySourceCard as SolCompanySourceCardData } from '../../data/sol/sol-contract';
import { formatInstant } from '../../lib/timezone';
import { SETTINGS_PATH } from '../settings/settings-route';

/**
 * The cited COMPANY DETAILS, as a card that opens Settings. M11 / I-072.
 *
 * **THE FACT OF A LOGO, NEVER THE LOGO.** The server never selects
 * `logo_base64`, so there is nothing here to render; the card says whether a
 * logo is saved, which is the product-facing fact. Contact details are shown
 * only when stored — "not stored" is said by the answer, not invented here.
 */
export interface SolCompanySourceCardProps {
  readonly card: SolCompanySourceCardData;
  readonly timeZone: string | null;
}

export function SolCompanySourceCard({ card, timeZone }: SolCompanySourceCardProps) {
  const updated = timeZone ? formatInstant(card.updatedAt, timeZone) : '';
  const details = [
    card.contactEmail ? `Email ${card.contactEmail}` : null,
    card.contactPhone ? `Phone ${card.contactPhone}` : null,
    card.hasLogo ? 'Logo saved' : 'No logo saved',
  ].filter((line): line is string => line !== null);
  return (
    <Link
      className="sol-source sol-source--company"
      to={SETTINGS_PATH}
      aria-label={`Open company details for ${card.companyName}`}
    >
      <span className="sol-source-head">
        <span className="sol-source-title">{card.companyName}</span>
        <span className="sol-source-status">Company</span>
      </span>
      <span className="sol-source-meta">
        {updated ? `Company details · Updated ${updated}` : 'Company details'}
      </span>
      <span className="sol-source-caption">{details.join(' · ')}</span>
      <span className="sol-source-open" aria-hidden="true">
        Open Settings →
      </span>
    </Link>
  );
}
